import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { createSavedSearch } from 'constants/routes'

function saveSearchInformation(payload) {
  return fromFetch(createSavedSearch, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(payload),
  }).pipe(
    switchMap((response) => response.json())
  );
}

export default saveSearchInformation;